import cn from "classnames";
import { type PropsWithChildren } from "react";
import { ColumnAlignment } from "@/constants/content";
import { MediaSize } from "@/constants/media";
import { getColumnAlignmentClassName } from "@/utils/style/getColumnAlignmentClassName";

export interface MediaLayoutProps {
  size?: MediaSize;
  alignment?: ColumnAlignment;
}

export default function MediaLayout(
  props: PropsWithChildren<MediaLayoutProps>,
) {
  const {
    children,
    size = MediaSize.Standard,
    alignment = ColumnAlignment.Center,
  } = props;

  const colsClassName = cn("col-12", {
    "col-md-10 col-lg-8": size === MediaSize.Standard,
  });
  const rowClassName = cn("row", getColumnAlignmentClassName(alignment));

  return (
    <div className={rowClassName}>
      <div className={colsClassName}>{children}</div>
    </div>
  );
}
